export default __webpack_public_path__ + "static/media/Thermador@3x.c61a583e.png";